import React, {useEffect} from 'react';
import {ArrowLeftOutlined, RightOutlined} from "@ant-design/icons";
import {DIR_RTL} from "../../../constants/ThemeConstant";
import {Link, useHistory} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import Title from "antd/es/typography/Title";
import {Skeleton} from 'antd';
import {APP_PREFIX_PATH} from "../../../configs/AppConfig";
import {getPickup, selectBranch} from 'redux/actions';

function Branches() {
    const {theme: {direction, locale}, fetchedData: {pickups}} = useSelector(state => state);
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo({top:0, behavior: 'auto'});
        dispatch(getPickup());
    }, []);

    return (
        <>
            <div className="mt-2 py-2 border-bottom">
                <h3 onClick={() => history.push(APP_PREFIX_PATH.concat('/menu'))}
                    className='order-mode__prev border-0 text-center'>
                    Branches <ArrowLeftOutlined rotate={direction === DIR_RTL ? 180 : 0}/>
                </h3>
            </div>
            {pickups.length === 0 ?
                <>
                    <Skeleton active paragraph={{rows: 2, width: ['100', '100']}}/>
                    <Skeleton active paragraph={{rows: 2, width: ['100', '100']}}/>
                </> :
                <div className="pt-2 px-3">
                    {pickups.map(branch => <Link to={APP_PREFIX_PATH + '/branches/' + branch?.id} key={branch?.id}>
                        <div className="menu-actions__item" onClick={() => dispatch(selectBranch(branch?.id))}>
                            <div>
                                <h4 className='menu-action__text mb-1'>{locale === 'en' ? branch?.nameEng : branch?.nameAr} Branch</h4>
                                <Title className='mb-0' level={4} type="secondary">
                                    {locale === 'en' ? branch?.addressEng : branch?.addressAr}
                                </Title>
                            </div>
                            <RightOutlined rotate={direction === DIR_RTL ? 180 : 0} className='menu-action__icon m-0'/>
                        </div>
                    </Link>)}
                    {/* <div onClick={() => history.push(APP_PREFIX_PATH.concat('/branches/1'))} className="menu-actions__item">
                    <div>
                        <h4 className='menu-action__text mb-1'>Qurain Branch</h4>
                        <Title className='mb-0' level={4} type="secondary">12 St, Qurain, Kuwait City</Title>
                    </div>
                    <RightOutlined rotate={direction === DIR_RTL ? 180 : 0} className='menu-action__icon m-0'/>
                </div> */}
                </div>
            }
        </>
    );
}

export default Branches;